import { render, staticRenderFns } from "./PricingSection.vue?vue&type=template&id=778bc312&scoped=true&"
import script from "./PricingSection.vue?vue&type=script&lang=js&"
export * from "./PricingSection.vue?vue&type=script&lang=js&"
import style0 from "./PricingSection.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./PricingSection.vue?vue&type=style&index=1&id=778bc312&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778bc312",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VDivider,VRow})
